import React from 'react';
import styled from 'styled-components';
import theme from '../theme';

const Container = styled.div`
  display: grid;
  position: relative;
  left: 0%;
  z-index: var(--layers-tooltips);

  @media (min-width: ${theme.breakpoints.md}) {
    left: -50%;
  }

  & > svg {
    cursor: pointer;
  }

  & > span {
    display: inline-block;
    position: absolute;
    padding: 15px;
    width: 250px;
    background-color: var(--colors-primary-blue-6);
    color: var(--colors-neutral-white);
    ${theme.font.body.xs}
    top: 25px;
    left: -140px;
  }

  &:hover > span {
    visibility: visible;
  }

  & > span::after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 8px 8px;
    border-color: var(--colors-primary-blue-6) transparent;
    top: -8px;
    left: 40%;

    @media (min-width: ${theme.breakpoints.md}) {
      left: 50%;
      top: -8px;
    }
  }
`;

const Tooltip: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <Container>
      <span>{children}</span>
    </Container>
  );
};

export default Tooltip;
